<!-- <app-mytel-header></app-mytel-header> -->
<menu-nav [listMenus]="menus" [contentTpl]="contentTpl" [isCollapsed]="isCollapsed" [isHorizontal]="isHorizontal"
             (onLogout)="logout()" xmlns=""
             [username]="user"></menu-nav>
<ng-template #contentTpl>
  <nz-layout class="vh-100">
    <div class="h-100">
      <!-- <nz-header class="header-container">
        <div class="module">
          {{ getModuleName() }}
        </div>
        <div class="breadcrumb">
          <app-breadcrumb></app-breadcrumb>
        </div>
      </nz-header> -->
      <nz-content class="full-content">
        <div class="router-content" >
          <!-- <app-alert></app-alert> -->
          <router-outlet></router-outlet>
        </div>
      </nz-content>
      <!-- <nz-footer class="footer-container">
        <span>© Viettel IT Center 2025</span>
      </nz-footer> -->
    </div>
  </nz-layout>
</ng-template>
